import { Grid } from '@mui/material'
import { SelectOption } from '../../../services/dashboardService'
import { ManagerBookingOptions, BOOKING_FOR_OPTIONS } from '../consts'
import EmployeeAutoComplete from './EmployeeAutoComplete'
import DropdownMenu from '../../../shared/UI/DropdownMenu'
import actionsService from '../../../services/actionsService'

interface BookingForControlsProps {
  bookingFor: ManagerBookingOptions
  selectedEmployee?: SelectOption
  employees: SelectOption[]
  onBookingForChange: (bookingFor: ManagerBookingOptions, employee?: SelectOption) => void
  useGridLayout?: boolean
}

export function BookingForControls({
  bookingFor,
  selectedEmployee,
  employees,
  onBookingForChange,
  useGridLayout = false,
}: BookingForControlsProps) {
  const shouldRenderEmployeeSelect = bookingFor === ManagerBookingOptions.EMPLOYEE && employees?.length

  const handleBookingForSelectChange = (selectedValue: number) => {
    if (selectedValue === ManagerBookingOptions.MYSELF || selectedValue === ManagerBookingOptions.VISITOR) {
      onBookingForChange(selectedValue, undefined)
    } else {
      onBookingForChange(selectedValue, selectedEmployee)
    }
  }

  const handleEmployeeChange = (employee: SelectOption | null) => onBookingForChange(bookingFor, employee ?? undefined)

  // Filter out Employee option if no employees available
  const bookingForOptions = employees?.length
    ? BOOKING_FOR_OPTIONS
    : BOOKING_FOR_OPTIONS.filter(option => option.value !== ManagerBookingOptions.EMPLOYEE)

  const renderBookingForSelect = () =>
    (
      <DropdownMenu
        label="Booking For"
        data={bookingForOptions}
        textField="displayValue"
        valueField="value"
        id="bookingFor"
        value={bookingFor}
        onChange={e => handleBookingForSelectChange(Number(e.target.value))}
        onOpen={() => actionsService.userAnalytics.postEvent('UIClickEvent', 'BookingForDropdownClick', window.location.pathname, window.location.hostname)}
      />
    )

  const renderEmployeeSelect = () => 
    (
      <EmployeeAutoComplete
        id="employees"
        label="All Employees"
        data={employees}
        textField="displayValue"
        value={selectedEmployee}
        onInputRef={ref => {
          if (selectedEmployee) {
            return
          }
          ref?.focus()
        }}
        onChange={(_e, employee) => handleEmployeeChange(employee)}
        onOpen={() => actionsService.userAnalytics.postEvent('UIClickEvent', 'BookingEmployeeDropdownClick', window.location.pathname, window.location.hostname)}
      />
    )

  if (useGridLayout) {
    return (
      <>
        <Grid item xs={12}>
          {renderBookingForSelect()}
        </Grid>
        {shouldRenderEmployeeSelect && (
          <Grid item xs={12}>
            {renderEmployeeSelect()}
          </Grid>
        )}
      </>
    )
  }

  return (
    <>
      {renderBookingForSelect()}
      {shouldRenderEmployeeSelect && renderEmployeeSelect()}
    </>
  )
}